import React from 'react';

const WhatYouLike = () => {
    return (
        <div className='container w-full mx-auto py-20'>
            <div className="p-5">
                <h1 className="text-3xl md:text-6xl font-bold fw-bold capitalize" style={{ fontFamily: "Rajdhani" }}>What do <span className="bg-gray-200">you like</span> today?</h1>
                <p className="pt-7">Consectetur numquam poro nemo veniam
                    eligendi rem adipisci quo modi.</p>
            </div>

            <div className=" grid grid-cols-1 md:grid-cols-2 gap-5 px-5 pt-16">
                <div className="flex h-[200px] group justify-start hover:shadow gap-2 px-7 py-5 w-full bg-[#F9FAFC] items-center">
                    <div className="p-5 group-hover:-mt-5 duration-200">
                        <img src="https://elanta.app/nazar/starbelly-demo/img/categories/1.png" alt="" className="object-cover w-24 md:w-32" />
                        <div className="bg-[#ffaa00] rounded-full w-7 h-7 mx-auto -mt-3 group-hover:w-10 group-hover:h-10 duration-200"></div>

                    </div>
                    <div className="flex flex-col px-3 gap-2">
                        <h3 className="font-bold text-xl md:text-3xl capitalize">Starters</h3>
                        <h3 className="capitalize text-sm md:text-md">Amazing foods for the mind and body.</h3>
                    </div>
                </div>
                <div className="flex h-[200px] group hover:shadow justify-start gap-2 px-7 py-5 w-full bg-[#F9FAFC] items-center">
                    <div className="p-5 group-hover:-mt-5 duration-200">
                        <img src="https://elanta.app/nazar/starbelly-demo/img/categories/2.png" alt="" className="object-cover w-24 md:w-32" />
                        <div className="bg-[#ffaa00] rounded-full w-7 h-7 mx-auto -mt-3 group-hover:w-10 group-hover:h-10 duration-200"></div>

                    </div>
                    <div className="flex flex-col px-3 gap-2">
                        <h3 className="font-bold text-xl md:text-3xl capitalize">Main Dishes</h3>
                        <h3 className="capitalize text-sm md:text-md">Mouth watering Hot Recipes.</h3>
                    </div>
                </div>
                <div className="flex h-[200px] group hover:shadow justify-start gap-2 px-7 py-5 w-full bg-[#F9FAFC] items-center">
                    <div className="p-5 group-hover:-mt-5 duration-200">
                        <img src="https://elanta.app/nazar/starbelly-demo/img/categories/3.png" alt="" className="object-cover w-24 md:w-32" />
                        <div className="bg-[#ffaa00] rounded-full w-7 h-7 mx-auto -mt-3 group-hover:w-10 group-hover:h-10 duration-200"></div>

                    </div>
                    <div className="flex flex-col px-3 gap-2">
                        <h3 className="font-bold text-xl md:text-3xl capitalize">Drinks</h3>
                        <h3 className="capitalize text-sm md:text-md">It's like a party for my taste buds.</h3>
                    </div>
                </div>
                <div className="flex h-[200px] group hover:shadow justify-start gap-2 px-7 py-5 w-full bg-[#F9FAFC] items-center">
                    <div className="p-5 group-hover:-mt-5 duration-200">
                        <img src="https://elanta.app/nazar/starbelly-demo/img/categories/4.png" alt="" className="object-cover w-24 md:w-32" />
                        <div className="bg-[#ffaa00] rounded-full w-7 h-7 mx-auto -mt-3 group-hover:w-10 group-hover:h-10 duration-200"></div>

                    </div>
                    <div className="flex flex-col px-3 gap-2">
                        <h3 className="font-bold text-xl md:text-3xl capitalize">Desserts</h3>
                        <h3 className="capitalize text-sm md:text-md">See How Far The Sweetness Go.</h3>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default WhatYouLike;